// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3vP2W","inputWrap":"styles_inputWrap__16xj4","input":"styles_input__2H3cy"};